import React from 'react';
import {
  Snackbar,
  Alert,
  Button,
  Typography
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { useCacheManager } from '../../hooks/useCacheManager';

const UpdateNotification: React.FC = () => {
  const { isUpdateAvailable, forceReload, clearCaches } = useCacheManager();
  const [dismissed, setDismissed] = React.useState(false);

  const handleUpdate = async () => {
    await clearCaches();
    forceReload();
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  if (!isUpdateAvailable || dismissed) {
    return null;
  }

  return (
    <Snackbar
      open={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{ marginTop: 16 }}
    >
      <Alert
        severity="info"
        style={{ minWidth: 400 }}
        action={
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              color="inherit"
              size="small"
              onClick={handleUpdate}
              startIcon={<RefreshIcon />}
              style={{ fontWeight: 'bold' }}
            >
              Update
            </Button>
            <Button
              color="inherit"
              size="small"
              onClick={handleDismiss}
              style={{ minWidth: 'auto', padding: 8 }}
            >
              <CloseIcon fontSize="small" />
            </Button>
          </div>
        }
      >
        <div>
          <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: 4 }}>
            New Version Available
          </Typography>
          <Typography variant="body2">
            A new version of Prismatic Forge is available. Update now to get the latest features and improvements.
          </Typography>
        </div>
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotification;